export enum MfaTypeEnum {
  Ga = 1,
  Pin = 2,
  Sms = 3,
  Call = 4,
}
